import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { computed, ref } from 'vue'

export interface WorkspaceOptions {
  is_funding_application_enabled: boolean
  is_public_investor_registration_enabled: boolean
}

export interface Workspace {
  name: string
  subdomain: string
  options: WorkspaceOptions
  membership_agreement?: {
    id: number
    filename: string
    url: string
  }
}

export const useWorkspaceStore = defineStore('public/workspaceStore', () => {
  const workspace = ref<Workspace>(null)

  /////////////////////////////////////////////////////////////////////////////
  // Actions
  /////////////////////////////////////////////////////////////////////////////

  const fetchWorkspace = async (slug) => {
    const data = await useFetch(`/v4/${slug}/public/workspace/current`).get<Workspace>()
    workspace.value = { ...data }
  }

  return {
    workspace,
    fetchWorkspace,
  }
})
